import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useAllMetrics } from 'features/metrics/useAllMetrics';
import { getMetricValue, getMeasureName } from './claimsTrendMetricsCardHelper';
import { IconArrowNarrowUp, IconArrowNarrowDown } from '@tabler/icons-react';
import { MetricCardErrorState, MetricCardLoadingState, MetricCardNoDataText } from './MetricCardStates';

const HighCostClaimantsMetricsCard = ({ workBookName, width, height, enablePriorComparison = true }) => {

  // Use unified all-metrics VDS hook (single call for all 8 tiles)
  const { data: metricsData, loading, error } = useAllMetrics();

  // Safely extract the value
  let extractedValue = null, percentageDifferenceBetweenCurrentAndPrior = null;
  extractedValue = getMetricValue(metricsData, getMeasureName(workBookName, null, null));
  percentageDifferenceBetweenCurrentAndPrior = enablePriorComparison
    ? getMetricValue(metricsData, '% Diff HCC per 1000')
    : null;

  // Show loading skeleton while data is being fetched
  if (loading) {
    return <MetricCardLoadingState width={width} height={height} borderRadius="26px" />;
  }

  if (error) {
    return <MetricCardErrorState title="High Cost Claimants per 1,000" titleSx={{ whiteSpace: 'nowrap' }} />;
  }
  if(error || !metricsData || extractedValue === null || extractedValue === undefined) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        height: '176px',
        padding: '24px',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '8px',
        alignSelf: 'stretch',
        borderRadius: '16px',
        border: '1px solid var(--Gray---Line-Stroke, #71767A)',
        background: 'var(--white-bi, #FFF)',
      }}
    >
      <Typography 
        sx={{ 
          color: 'var(--Gray-Darkest---Body-Text, #121A22)', 
          fontFamily: 'Noto Sans',
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: 600,
          lineHeight: '150%',
          whiteSpace: 'nowrap'
        }}
      >
        High Cost Claimants per 1,000
      </Typography>
      <Typography
        sx={{
          color: 'var(--Gray-Darkest---Body-Text, #121A22)',
          fontFamily: 'Noto Sans',
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: '150%',
          mt: '-4px',
        }}
      >
        Threshold: $100K
      </Typography>
      {extractedValue != null ? (
      <Box sx={{ display: 'flex', alignItems: 'baseline', alignSelf: 'stretch', marginTop: 'auto' }}>
        <Typography
          sx={{
            fontSize: '20px',
            fontWeight: 400,
            fontStyle: 'normal',
            fontFamily: 'Noto Sans',
            color: '#121A22',
            lineHeight: '150%',
          }}
        >
          {`${parseFloat(extractedValue).toFixed(2)}`}
        </Typography>
        {percentageDifferenceBetweenCurrentAndPrior !== null && <>
        <Box
          sx={{
            flex: '1 0 0',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'flex-end',
            alignItems: 'center',
            columnGap: '4px',
          }}
        >
          <Typography
            component="span"
            sx={{
              color: '#121A22',
              fontFamily: 'Noto Sans',
              fontSize: '14px',
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: '150%',
              whiteSpace: 'nowrap',
            }}
          >
            {`${percentageDifferenceBetweenCurrentAndPrior != null ? parseFloat(percentageDifferenceBetweenCurrentAndPrior).toFixed(2) : '—'}% vs prior`}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              width: 16,
              height: 16,
              justifyContent: 'center',
              alignItems: 'center',
              flexShrink: 0,
            }}
          >
            {parseFloat(percentageDifferenceBetweenCurrentAndPrior) > 0 ? (
              <IconArrowNarrowUp size={16} color="#9D0038" />
            ) : (
              <IconArrowNarrowDown size={16} color="#2fd34aff" />
            )}
          </Box>
        </Box>
        </>}
      </Box>
       ) : (
        <MetricCardNoDataText />
      )}
    </Box>
  );
};

export default HighCostClaimantsMetricsCard;